import React, { Component } from 'react';
import { bool, string } from 'prop-types';
import { eventListener, expression, formatters } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { ChangeEvent, FocusEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { MessageService, ModelService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, defaultClasses, generateUUID, isContentfulString, isFunction } from '@philips-internal/oswald-ui-utils';
class RadioButton extends Component {
    constructor() {
        super(...arguments);
        this.onChange = (event) => {
            const { onChange, formatters } = this.props;
            const { label } = ModelService.formatProps(this.props, ['label'], formatters);
            onChange && onChange(new ChangeEvent({
                oldValue: Boolean(event.target.value),
                prettyValue: label,
                value: Boolean(event.target.value),
            }));
        };
        this.onBlur = () => {
            const { onBlur } = this.props;
            isFunction(onBlur) && onBlur(new FocusEvent());
        };
        this.onFocus = () => {
            const { onFocus } = this.props;
            isFunction(onFocus) && onFocus(new FocusEvent());
        };
    }
    formatLabel() {
        const { formatters } = this.props;
        const { label } = ModelService.formatProps(this.props, ['label'], formatters);
        return label;
    }
    formatValue() {
        const { formatters } = this.props;
        const { value } = ModelService.formatProps(this.props, ['value'], formatters);
        return value;
    }
    render() {
        const { checked, className, enabled = RadioButton.defaultProps.enabled, name, readOnly = RadioButton.defaultProps.readOnly, uuid = RadioButton.defaultProps.uuid, } = this.props;
        const id = isContentfulString(uuid) ? uuid : generateUUID();
        const rootClasses = {
            'c-radio-button': true,
            [`${className}`]: Boolean(className),
            ...defaultClasses({ enabled, readOnly }),
        };
        return (React.createElement("div", { className: classNames(rootClasses) },
            React.createElement("input", { checked: checked, className: "c-radio-button__input", disabled: readOnly || !enabled, id: id, name: name, onBlur: this.onBlur, onChange: this.onChange, onFocus: this.onFocus, tabIndex: 0, type: "radio", value: this.formatValue() }),
            React.createElement("label", { className: "c-radio-button__label", htmlFor: id }, MessageService.translate(this.formatLabel()))));
    }
}
RadioButton.propTypes = {
    checked: bool,
    className: string,
    enabled: bool,
    formatters: formatters,
    label: expression,
    name: string,
    onBlur: eventListener,
    onChange: eventListener,
    onFocus: eventListener,
    readOnly: bool,
    uuid: string,
    value: string,
};
RadioButton.defaultProps = {
    enabled: true,
    readOnly: false,
    uuid: '',
};
export { RadioButton, };
//# sourceMappingURL=radio-button.js.map